export enum ETenantRolesTag {
    DEFAULT = 'default',
    MASTER = 'master',
  }